import { UserRole } from '@shared/types/user';

export const DIVIDER_NAME = 'divider';

export interface MenuItem {
  name: string;
  url: string;
  icon: string;
  permission: UserRole[];
}

export const DIVIDER: MenuItem = {
  name: DIVIDER_NAME,
  url: '',
  icon: '',
  permission: [UserRole.Admin, UserRole.ClientAdmin],
};
